export default "__VITE_ASSET__Cog4TQDS__"